import { render, staticRenderFns } from "./Pesquisar.vue?vue&type=template&id=e8b2994e&"
import script from "./Pesquisar.vue?vue&type=script&lang=js&"
export * from "./Pesquisar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports